<script setup lang="ts">
interface Props {
  statusCode?: number
  title?: string
  subtitle?: string
  showCompanyJobsButton?: boolean
  companySlug?: string
}

const props = withDefaults(defineProps<Props>(), {
  statusCode: 404,
  title: 'This page has moved or no longer exists.',
  subtitle: 'Try going back to the site!',
  showCompanyJobsButton: false,
  companySlug: ''
})

const handleGoHome = () => {
  navigateTo('/')
}
</script>

<template>
  <div class="bg-gray-50 min-h-[calc(100vh-200px)] flex items-center">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20 text-center w-full">
      <h1 class="text-8xl md:text-9xl font-bold text-primary-500 leading-none mb-6">
        {{ statusCode }}
      </h1>

      <h2 class="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
        {{ title }}
      </h2>

      <p class="text-lg text-gray-500 mb-8">
        {{ subtitle }}
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          v-if="showCompanyJobsButton && companySlug"
          :to="`/company/${companySlug}/jobs`"
          color="gray"
          variant="outline"
          size="lg"
          label="View company jobs"
        />
        <button
          v-else
          class="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
          @click="handleGoHome"
        >
          Go back to site
        </button>
        <NuxtLink
          to="/jobs"
          class="px-6 py-3 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium text-center"
        >
          Search jobs
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
